{
  "remove": "Pašalinti"
}
